// Server-Sent Events frame parser for the Netwatch chat stream.
//
// The backend streams `event:`/`data:` frames separated by a blank line.
// `parseSSE` pulls complete frames off the front of a growing buffer and
// returns the still-incomplete remainder so the caller can keep appending.

/** One decoded SSE frame. Backend payloads are dynamic, so `data` is open. */
export interface ParsedEvent {
  event: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
}

export function parseSSE(buffer: string): { events: ParsedEvent[]; rest: string } {
  const events: ParsedEvent[] = []
  let rest = buffer
  while (true) {
    const idx = rest.indexOf('\n\n')
    if (idx === -1) break
    const block = rest.slice(0, idx)
    rest = rest.slice(idx + 2)
    let event = 'message'
    let data = ''
    for (const line of block.split('\n')) {
      if (line.startsWith('event:')) event = line.slice(6).trim()
      else if (line.startsWith('data:')) data += line.slice(5).trim()
    }
    if (data) {
      try {
        events.push({ event, data: JSON.parse(data) })
      } catch {
        events.push({ event, data: { raw: data } })
      }
    }
  }
  return { events, rest }
}
